import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'of-scroll-progress',
  styleUrl: 'of-scroll-progress.scss',
})
export class OfScrollProgress {
  private footer = document.querySelector('footer');
  private offset = 50;

  private progressWrap?: any;
  private progressPath?: any;
  private pathLength: number;

  componentDidLoad() {
    this.pathLength = this.progressPath.getTotalLength();
    this.progressPath.style.transition = this.progressPath.style.WebkitTransition = 'none';
    this.progressPath.style.strokeDasharray = this.pathLength + ' ' + this.pathLength;
    this.progressPath.style.strokeDashoffset = this.pathLength;
    this.progressPath.getBoundingClientRect();
    this.progressPath.style.transition = this.progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

    this.updateProgress();
    window.addEventListener('scroll', () => {
      this.updateProgress();
      if (window.scrollY > this.offset) {
        this.progressWrap.classList.add('active-progress');
      } else {
        this.progressWrap.classList.remove('active-progress');
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.updateProgress);
  }

  updateProgress() {
    const scroll = window.scrollY;
    const height = document.body.scrollHeight - window.innerHeight;
    const progress = this.pathLength - (scroll * this.pathLength) / height;
    this.progressPath.style.strokeDashoffset = progress;
    if (this.footerInViewport()) {
      this.footer.classList.add('show-gradient');
    } else {
      this.footer.classList.remove('show-gradient');
    }
  }

  footerInViewport() {
    if (this.footer) {
      const footerPosition = this.footer.getBoundingClientRect();
      return footerPosition.top - window.innerHeight < 0;
    }
    return false;
  }

  goToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  render() {
    return (
      <Host>
        <div class="progress-wrap" ref={el => (this.progressWrap = el)} onClick={this.goToTop}>
          <svg class="progress-circle svg-content" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" ref={el => (this.progressPath = el)} />
          </svg>
          <lg-icon name="arrow-top" class="icon"></lg-icon>
        </div>
      </Host>
    );
  }
}
